import { Component, computed, inject, input } from '@angular/core';
import { CreateAufgabeFormService } from '../../create-aufgabe-dialog/create-aufgabe.formservice';
import { RegisterName } from '@schir-int-client/register-shared';
import { AufgabenTyp } from '@schir-int-client/aufgabe-shared';

@Component({
	selector: 'schir-int-client-aufgabe-mitteilung-editor',
	templateUrl: './aufgabe-mitteilung-editor.component.html',
	styleUrls: ['./aufgabe-mitteilung-editor.component.scss'],
	standalone: false,
})
export class AufgabeMitteilungEditorComponent {
	private readonly formService: CreateAufgabeFormService = inject(CreateAufgabeFormService);

	readonly register = input.required<RegisterName>();
	readonly excludeEingetragenerEigentuemer = input(true);

	protected readonly isBSR = computed(() => this.register() === RegisterName.BSR);

	readonly mitteilungen = EintragungsmitteilungMitteilungen;

	protected readonly formGroup = this.formService.form.controls.EINTRAGUNGSMITTEILUNG;
	protected readonly bodyControls = this.formGroup.controls.body.controls;
	protected readonly eigentuemerNeuControls = this.bodyControls.eigentuemerNeuMitteilung.controls;
	protected readonly eigentuemerAltControls = this.bodyControls.eigentuemerAltMitteilung.controls;
	protected readonly eingetragenerEigentuemerControls = this.bodyControls.eingetragenerEigentuemerMitteilung.controls;
	protected readonly glaeubigerNeuControls = this.bodyControls.glaeubigerNeuMitteilung.controls;
	protected readonly glaeubigerAltControls = this.bodyControls.glaeubigerAltMitteilung.controls;
	protected readonly notarControls = this.bodyControls.notarMitteilung.controls;
	protected readonly bshControls = this.bodyControls.bshMitteilung.controls;
	protected readonly rechtsanwaelteControls = this.bodyControls.rechtsanwaelteMitteilung.controls;

	protected toggleEigentuemerNeuMitteilungGroup(enable: boolean) {
		enable
			? this.bodyControls.eigentuemerNeuMitteilung.enable()
			: this.bodyControls.eigentuemerNeuMitteilung.disable();
	}

	protected toggleEigentuemerAltMitteilungGroup(enable: boolean) {
		enable
			? this.bodyControls.eigentuemerAltMitteilung.enable()
			: this.bodyControls.eigentuemerAltMitteilung.disable();
	}

	protected toggleEingetragenerEigentuemerMitteilungGroup(enable: boolean) {
		enable
			? this.bodyControls.eingetragenerEigentuemerMitteilung.enable()
			: this.bodyControls.eingetragenerEigentuemerMitteilung.disable();
	}

	protected toggleGlaeubigerNeuMitteilungGroup(enable: boolean) {
		enable
			? this.bodyControls.glaeubigerNeuMitteilung.enable()
			: this.bodyControls.glaeubigerNeuMitteilung.disable();
	}

	protected toggleGlaeubigerAltMitteilungGroup(enable: boolean) {
		enable
			? this.bodyControls.glaeubigerAltMitteilung.enable()
			: this.bodyControls.glaeubigerAltMitteilung.disable();
	}

	protected toggleNotarMitteilungGroup(enable: boolean) {
		enable ? this.bodyControls.notarMitteilung.enable() : this.bodyControls.notarMitteilung.disable();
	}

	protected toggleBshMitteilungGroup(enable: boolean) {
		enable ? this.bodyControls.bshMitteilung.enable() : this.bodyControls.bshMitteilung.disable();
	}

	protected toggleRechtsanwaltMitteilungGroup(enable: boolean) {
		enable
			? this.bodyControls.rechtsanwaelteMitteilung.enable()
			: this.bodyControls.rechtsanwaelteMitteilung.disable();
	}

	protected readonly AufgabenTyp = AufgabenTyp;
}

export enum EintragungsmitteilungMitteilungen {
	BLATTABSCHRIFT = 'mit Blattabschrift(en)',
	SCHIFFSZERTIFIKAT = 'mit der Bitte das Schiffszertifikat zur Berichtigung einzureichen',
	SCHIFFSBRIEF = 'mit der Bitte den Schiffsbrief zur Berichtigung einzureichen',
	ZERTIFIKATSAUSZUG = 'mit der Bitte den alten Zertifikatsauszug einzureichen',
	BEGLAUBIGTE_BLATTABSCHRIFT = 'mit beglaubigter Blattabschrift',
	BSH = 'BSH mit dem Zusatz, dass Eintragung im Zertifikat am gleichen Tag erfolgt ist',
}
